export default __webpack_public_path__ + "static/11663-2f480ce8ee9d6fef76693dae5b658040.jpg";